enum VerifyEmailResult {
  CODE_EXPIRED = -2,
  ERROR = -1,
  SUCCESS = 0
}

export default VerifyEmailResult;
